import React, { ReactNode } from "react";
import { Paragraph, ThemeUICSSObject } from "theme-ui";

const ClickLink = ({
  onClick,
  children,
  style,
}: {
  onClick: () => void;
  children: ReactNode;
  style?: ThemeUICSSObject;
}) => {
  return (
    <Paragraph
      sx={{
        color: "primary",
        cursor: "pointer",
        textDecoration: "underline",
        ...style,
      }}
      onClick={onClick}
    >
      {children}
    </Paragraph>
  );
};

export default ClickLink;
